import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

// theme can be 'light', 'dark', or 'system'
export function ThemeProvider({ children }) {
  const [themeMode, setThemeMode] = useState(() => localStorage.getItem('dq_theme') || 'system');
  const [resolvedTheme, setResolvedTheme] = useState('light');

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    function applyTheme() {
      let actual = themeMode;
      if (themeMode === 'system') {
        actual = mediaQuery.matches ? 'dark' : 'light';
      }
      setResolvedTheme(actual);
      document.documentElement.setAttribute('data-theme', actual);
    }

    applyTheme();
    mediaQuery.addEventListener('change', applyTheme);
    return () => mediaQuery.removeEventListener('change', applyTheme);
  }, [themeMode]);

  function setTheme(mode) {
    setThemeMode(mode);
    localStorage.setItem('dq_theme', mode);
  }

  return (
    <ThemeContext.Provider value={{ themeMode, resolvedTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
